import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AppRoutePaths } from 'app/enums/routes.enum';

import { AuthGuard } from 'app/infrastructure/route-guards/auth-guard.service';

import { FuseSharedModule } from '@fuse/shared.module';
import { Error404Component } from './errors/404/error-404.component';
import { Error404Module } from './errors/404/error-404.module';
import {SelectedTenantComponent} from "./pages/seleted-tenant/selected-tenant.component";
import {TenantSelectorComponent} from "./pages/tenant-selector/tenant-selector.component";
import {LoadClientThemeGuard} from "./infrastructure/route-guards/load-client-theme.guard";
import {AppFormComponent} from "./modules/app-form/form-test/app-form.component";
import {NoTenantGuard} from "./infrastructure/route-guards/no-tenant.guard";

const appRoutes: Routes = [
  // {
  //   path: 'auth-callback',
  //   loadChildren: () => import('app/auth-callback/auth-callback.module').then(m => m.AuthCallbackModule)
  // },
  // {
  //   path: 'logout-callback',
  //   loadChildren: () => import('app/logout-callback/logout-callback.module').then(m => m.LogoutCallbackModule)
  // },
  // {
  //   path: 'login',
  //   loadChildren: () => import('app/logout-callback/logout-callback.module').then(m => m.LogoutCallbackModule)
  // },
  // {
  //   path: 'form-test',
  //   component: AppFormComponent,
  // },
  {
    path: 'portal/:tenantId',
    component: SelectedTenantComponent,
    data: {
      navigation: 'main',
    },
    canActivate: [LoadClientThemeGuard],
    children: [
      {
        path: AppRoutePaths.HOME,
          loadChildren: () => import('app/pages/main-page/main-page.module').then(t => t.MainPageModule),
      },
      {
        path: AppRoutePaths.RESOURCES,
          loadChildren: () => import('app/pages/resources-page/resources-page.module').then(t => t.ResourcesPageModule),
      },
      {
        path: AppRoutePaths.FREQUENT_QUESTIONS,
          loadChildren: () => import('app/pages/frequent-questions-page/frequent-questions-page/frequent-questions.module').then(t => t.FrequentQuestionsModule),
      },
      {
        path: AppRoutePaths.REPORT_IRREGULARITY,
          loadChildren: () => import('app/pages/report-irregularity/report-irregularity.module').then(t => t.ReportIrregularityPageModule),
      },
      {
        path: AppRoutePaths.FOLLOW_UP,
          loadChildren: () => import('app/pages/follow-up/follow-up.module').then(t => t.FollowUpPageModule),
      },
      {
        path: AppRoutePaths.MAKE_QUESTION,
          loadChildren: () => import('app/pages/make-question/make-question.module').then(t => t.MakeQuestionPageModule),
      },
      {
        path: '**',
        redirectTo: AppRoutePaths.HOME,
      }
    ]
  },
  { path: AppRoutePaths.FORBIDDEN, loadChildren: () => import('app/errors/403/error-403.module').then(m => m.Error403Module) },
  { path: AppRoutePaths.ERROR, loadChildren: () => import('app/errors/500/error-500.module').then(m => m.Error500Module) },
  // { path: '**', loadChildren: () => import('app/errors/404/error-404.module').then(m => m.Error404Module)}
  {
    path: '',
    component: SelectedTenantComponent,
    data: {
      navigation: 'tenantSelector',
    },
    canActivate: [NoTenantGuard],
    children: [
      {
        path: AppRoutePaths.SELECT_TENANTS,
        component: TenantSelectorComponent,
        data: {
          moduleName: 'main',
        }
      },
      {
        path: AppRoutePaths.RESOURCES,
        loadChildren: () => import('app/pages/resources-page/resources-page.module').then(t => t.ResourcesPageModule),
      },
      {
        path: AppRoutePaths.FREQUENT_QUESTIONS,
        loadChildren: () => import('app/pages/frequent-questions-page/frequent-questions-page/frequent-questions.module').then(t => t.FrequentQuestionsModule),
      },
      { path: '**', redirectTo: `${AppRoutePaths.SELECT_TENANTS}` },
    ]
  },
  // { path: '**', redirectTo: `${AppRoutePaths.SELECT_TENANTS}` }, // Not needed since "path: '' " takes care of unknown routes also
  // {
  //   path: '404',
  //   component: Error404Component,
  // },
];

@NgModule({
  declarations: [
    // FormTestComponent,
  ],
  imports: [
    RouterModule.forRoot(appRoutes, {
      scrollPositionRestoration: 'enabled',
      enableTracing: false,
      onSameUrlNavigation: 'reload'
    }),
    Error404Module,
    FuseSharedModule,
  ],
  exports: [
    RouterModule,
  ]
})
export class AppRoutingModule { }

